import { Link } from "react-router-dom";
import logo from "@/assets/xperfomax-logo.png";

const Footer = () => {
  const primaryLinks = [
    { label: "Services", href: "/services" },
    { label: "Solutions", href: "/solutions" },
    { label: "Analytics", href: "/analytics" },
    { label: "Insights", href: "/blog" },
    { label: "Case Studies", href: "/case-studies" },
    { label: "Contact", href: "/contact" },
  ];

  return (
    <footer className="bg-[hsl(220,20%,12%)] text-[hsl(220,10%,70%)]">
      <div className="container-wide py-12 md:py-16">
        {/* Primary navigation */}
        <nav className="flex flex-wrap gap-x-8 gap-y-3 mb-10">
          {primaryLinks.map((link) => (
            <Link
              key={link.label}
              to={link.href}
              className="text-sm text-[hsl(220,10%,60%)] hover:text-[hsl(220,10%,85%)] transition-colors"
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* Soft close */}
        <p className="text-sm text-[hsl(220,10%,45%)] mb-10 max-w-md">
          Exploring a structured growth engagement?{" "}
          <Link
            to="/contact"
            className="text-[hsl(220,10%,60%)] hover:text-[hsl(220,10%,85%)] transition-colors"
          >
            Start a conversation
          </Link>
        </p>

        {/* Bottom governance line */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div className="flex items-center gap-6">
            <Link to="/" className="hover:opacity-80 transition-opacity">
              <img
                src={logo}
                alt="XperfoMax"
                width={43}
                height={24}
                className="h-4 w-auto brightness-75"
              />
            </Link>
            <span className="text-xs text-[hsl(220,10%,40%)]">
              © {new Date().getFullYear()} XperfoMax. Data-driven growth systems for accountable teams.
            </span>
          </div>
          <div className="flex items-center gap-6">
            <Link
              to="/about"
              className="text-xs text-[hsl(220,10%,40%)] hover:text-[hsl(220,10%,65%)] transition-colors"
            >
              Operating principles
            </Link>
            <Link
              to="/privacy"
              className="text-xs text-[hsl(220,10%,40%)] hover:text-[hsl(220,10%,65%)] transition-colors"
            >
              Privacy
            </Link>
            <Link
              to="/terms"
              className="text-xs text-[hsl(220,10%,40%)] hover:text-[hsl(220,10%,65%)] transition-colors"
            >
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
